<script>
  /**
   * Test IHM card CSS
   */
  import CardModel from "../components/ihm/CardModel.svelte";
  import CardInfo from "../components/ihm/CardInfo.svelte";
  import CardPrix from "../components/ihm/CardPrix.svelte";
  import CardProgress from "../components/ihm/CardProgress.svelte";
  import CardProgressFlat from "../components/ihm/CardProgressFlat.svelte";
</script>

<div class="container">
  <h5>CardModel</h5>
  <CardModel
    digitTitle="cherry"
    digitNbre="1200"
    digitText="Ceci est le texte"
  />

  <p>P. Sherman</p>
  <CardModel>
    <span slot="title"> P. Sherman </span>
    <span slot="subtitle">
      42 Wallaby Way<br />
      Sydney
    </span>
  </CardModel>

  <p>F.Laville = email</p>
  <CardModel>
    <span slot="title">F.Laville </span>

    <span slot="subtitle">
      12 Bd des allongés<br />
      Sydney
    </span>

    <span slot="email"> pipo@free.fr </span>
  </CardModel>

  <h5>CardProgressFlat</h5>

  <CardProgressFlat
    cardColor="cherry"
    cardTitle="vte Titre CardProgressFlat"
    cardNumber="2500"
    cardPourcent="38"
  />

  <h5>CardProgress</h5>
  <CardProgress
    cardColor="cherry"
    cardTitle="vte Titre CardProgress"
    cardNumber="2500"
    cardPourcent="38"
  />

  <h5>CardPrix</h5>
  <CardPrix
    cardColor="orange"
    cardTitle="Mon titre CardPrix"
    cardPrix="1500,00"
    cardList={["ele1", "ele2", "ele3"]}
  />

  <h5>CardInfo</h5>
  <CardInfo
    cardTitle="Mon titre CardInfo"
    cardSubTitle1="sous-titre1"
    cardSubTitle2="sous-titre2"
    cardSubTitle3="sous-titre3"
    cardColor="cherry"
    cardFooter="blue - green - orange - cherry - red"
  />
</div>
